/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Wechat_Mch_IdInputs */

const en_admin_settings_fields_wechat_mch_id = /** @type {(inputs: Admin_Settings_Fields_Wechat_Mch_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merchant ID`)
};

const zh_admin_settings_fields_wechat_mch_id = /** @type {(inputs: Admin_Settings_Fields_Wechat_Mch_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`商户号`)
};

/**
* | output |
* | --- |
* | "Merchant ID" |
*
* @param {Admin_Settings_Fields_Wechat_Mch_IdInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_wechat_mch_id = /** @type {((inputs?: Admin_Settings_Fields_Wechat_Mch_IdInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Wechat_Mch_IdInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_fields_wechat_mch_id(inputs)
	return zh_admin_settings_fields_wechat_mch_id(inputs)
});
export { admin_settings_fields_wechat_mch_id as "admin.settings.fields.wechat_mch_id" }